'use strict';

module.exports = Odigeo.Widget.extend({
    modelClass: require('../modules/models/accommodation_filter_by_name'),
    viewClass: require('../modules/views/accommodation_filter_by_name'),

    refreshData() {
        return this.model.refreshData();
    },

    onAccommodationSelected(value) {
        this.model.set('hotelName', value);

        return this.view.onElementClick();
    },

    onReturnInputValue(value) {
        this.model.set('hotelName', value);
    },
});
